import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { Navbar as SharedNavbar, type BreadcrumbItem } from '@valiant/ui-shared'
import { useLogoutMutation } from '../generated/graphql'
import { useAuth } from '../AuthProvider'
import { toast } from 'sonner'
import { environment } from '@/environment'

interface NavbarProps {
  breadcrumbs?: BreadcrumbItem[]
  hideBack?: boolean
}

export function Navbar({ breadcrumbs = [], hideBack = false }: NavbarProps) {
  const auth = useAuth()
  const navigate = useNavigate()

  const [{ data: logoutData, error: logoutError }, logout] = useLogoutMutation()

  const isSuperAdmin = auth?.auth?.role === 'SUPER_ADMIN'

  // on logout
  useEffect(() => {
    if (logoutData) {
      toast.success('Logged out successfully')
      auth.signout()
    }
  }, [logoutData, auth])

  // toast errors
  useEffect(() => {
    if (logoutError) {
      toast.error('Error', {
        description: logoutError.message,
      })
      auth.signout()
    }
  }, [logoutError, auth])

  const handleLogout = async () => {
    await logout({})
  }

  const handleSettingsClick = () => {
    navigate(`/users/${auth.auth?.userId}/settings`)
  }

  return (
    <SharedNavbar
      breadcrumbs={breadcrumbs}
      hideBack={hideBack}
      appName={environment.MSB}
      tagText="Admin Dashboard"
      onLogout={handleLogout}
      onSettingsClick={handleSettingsClick}
      showMaintenanceModeToggle={isSuperAdmin}
    />
  )
}
